import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Toast,
  ToastBody,
  ToastHeader
} from "reactstrap";
import Select from 'react-select';
import { TripModal } from "../../../Components/Common/TripModal/tripModal";
import { Formik } from "formik";
import { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllVehicleList,
  getAllDriverList,
  createTrips,
  updateTrips,
  getAllTripsList
} from "../../../slices/thunks";
import { hideErrorMessage } from "../../../slices/tripsDetails/reducer";
import "../TripList/style/tripList.scss";

const stateList = [
  {
    value: "CURRENT",
    label: "Current",
  },
  {
    value: "NEXT",
    label: "Next",
  },
  {
    value: "COMPLETED",
    label: "Completed",
  },
];

export const AddTripsModal = ({
  tripsById,
  addTripModal,
  toggleAddTripModal,
  isAdd,
  loading,
  currentPage,
  pageSize,
  searchText,
  selectedItem
}) => {
  const formikRef = useRef(null);
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(false);
  const [toasterType, setToasterType] = useState("success");
  const [toastMessage, setToastMessage] = useState("");

  const driverList = useSelector(
    (state) => state.DriverManagementSlice.driverList
  );
  const vehicleList = useSelector((state) => state.Vehicle.vehicleList);

  useEffect(() => {
    try {
      dispatch(getAllDriverList("None", "None", ""));
      dispatch(getAllVehicleList("None", "None", ""));
    } catch (error) {}
  }, [dispatch]);

  const addInitialValues = {
    trip_id: "",
    drivers: [],
    vehicle: "",
    customer: "",
    start_date: "",
    start_time: "",
    start_location: "",
    end_location: "",
    end_date: "",
    end_time: "",
    half: "",
    state: "",
    price_per_km: "",
    invoice_reference: "",
    invoice: "",
    notes: "",
  };

  const updateInitialValues = {
    trip_id: tripsById?.trip_id || "",
    drivers: tripsById?.drivers || [],
    vehicle: tripsById?.vehicle || "",
    customer: tripsById?.customer || "",
    start_date: tripsById?.start_date || "",
    start_time: tripsById?.start_time || "",
    start_location: tripsById?.start_location || "",
    end_location: tripsById?.end_location || "",
    end_date: tripsById?.end_date || "",
    end_time: tripsById?.end_time || "",
    half: tripsById?.half || "",
    state: tripsById?.state || "",
    price_per_km: tripsById?.price_per_km || "",
    invoice_reference: tripsById?.invoice_reference || "",
    invoice: tripsById?.invoice || "",
    notes: tripsById?.notes || "",
  };



  const showToaster = (isSuccess, message) => {
    setShowToast(true);
    setToasterType(isSuccess ? "success" : "danger");
    setToastMessage(message);
    setTimeout(() => {
      setShowToast(false);
      toggleAddTripModal();
      dispatch(getAllTripsList(currentPage, pageSize, searchText,selectedItem.toLowerCase() , "", ""));
      if (!isSuccess) {
        dispatch(hideErrorMessage());
      }
    }, 3000);
  };

  const handleTripsSubmit = async (values) => {
    try {
      let response;
      if (!isAdd) {
        response = await dispatch(updateTrips(tripsById.id, values));
      } else {
        response = await dispatch(createTrips(values));
      }
      const { success: isSuccess, message } = response;
      showToaster(isSuccess, message);
    } catch (error) {
      showToaster(false, error.message || "An unexpected error occurred");
    }
  };

  const vehicleOptions = useMemo(() => {
    const allVehicles = Array.isArray(vehicleList) ? vehicleList : [];
    const activeVehicles = allVehicles.filter(v => v.status === "active");

    let options = activeVehicles.map(vehicle => ({
      value: String(vehicle.id),
      label: `${vehicle.number_plate}`,
      status: vehicle.status,
    }));

    if (!isAdd && updateInitialValues?.vehicle) {
      const selectedVehicle = allVehicles.find(
        v => String(v.id) === String(updateInitialValues.vehicle)
      );

      const alreadyExists = options.some(opt => opt.value === String(selectedVehicle?.id));
      if (selectedVehicle && !alreadyExists) {
        options.push({
          value: String(selectedVehicle.id),
          label: `${selectedVehicle.number_plate}`,
          status: selectedVehicle.status,
        });
      }
    }

    return options;
  }, [vehicleList, isAdd, updateInitialValues?.vehicle]);

  return (
    <TripModal
      isModalOpen={addTripModal}
      toggleModal={toggleAddTripModal}
      buttonText={isAdd ? "Add" : "Update"}
      closeText={"Close without saving"}
      title={isAdd ? "Add trip" : "Update Trip"}
      tripText={isAdd ? "Add a new trip" : "Update trip"}
      showcloseIcon={true}
      size="lg"
      loading={loading}
      onSubmit={() => {
        if (formikRef.current) {
          formikRef.current.handleSubmit();
        }
      }}
    >
      <div className="px-3 d-flex flex-column gap-4">
        <div
          className="position-fixed top-0 end-0 p-3"
          style={{ zIndex: 1055 }}
        >
          <Toast isOpen={showToast}>
            <ToastHeader
              icon={toasterType === "danger" ? "danger" : "success"}
              toggle={() => setShowToast(false)}
            >
              {toasterType === "danger" ? "Error" : "Success"}
            </ToastHeader>
            <ToastBody>{toastMessage}</ToastBody>
          </Toast>
        </div>

        <Formik
          innerRef={formikRef}
          enableReinitialize
          initialValues={isAdd ? addInitialValues : updateInitialValues}
          onSubmit={handleTripsSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="trip_id" className="passwordLabel">
                        Trip ID
                      </Label>
                      <Input
                        type="text"
                        name="trip_id"
                        className="profileInput"
                        id="trip_id"
                        placeholder="Enter Trip ID"
                        value={values.trip_id}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("trip_id", e.target.value)}
                        invalid={touched.trip_id && errors.trip_id ? true : false}
                        disabled={!isAdd}
                      />
                      {touched.trip_id && errors.trip_id ? (
                        <FormFeedback>{errors.trip_id}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="customer" className="passwordLabel">
                        Customer
                      </Label>
                      <Input
                        type="text"
                        name="customer"
                        className="profileInput"
                        id="customer"
                        placeholder="Enter customer"
                        value={values.customer}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("customer", e.target.value)}
                        invalid={touched.customer && errors.customer ? true : false}
                      />
                      {touched.customer && errors.customer ? (
                        <FormFeedback>{errors.customer}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="drivers" className="passwordLabel">
                        Driver(s)
                      </Label>
                      <Select
                        isMulti
                        name="drivers"
                        options={driverList
                          .filter(driver => driver.status === "active")
                          .map(driver => ({
                            value: driver.id,
                            label: `${driver.first_name} ${driver.last_name}`,
                          }))}
                        classNamePrefix="select"
                        value={values.drivers.map(driverId => {
                          const driver = driverList.find(d => d.id === driverId);
                          return {
                            value: driverId,
                            label: driver
                              ? `${driver.first_name} ${driver.last_name}`
                              : `Driver ID: ${driverId}`,
                          };
                        })}
                        onChange={(selectedOptions) => {
                          const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
                          setFieldValue("drivers", selectedIds);
                        }}
                        onBlur={() => {
                          handleBlur({ target: { name: "drivers" } });
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            backgroundColor: "#f4f4f4",
                            border: "none",
                            borderBottom: "1px solid #8d8d8d",
                            minHeight: "44px",
                            height: "43px",
                            boxShadow: "none",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "43px",
                            padding: "0 6px",
                            overflow: "auto",
                            backgroundColor: "transparent",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "43px",
                            backgroundColor: "transparent",
                          })
                        }}
                      />
                      {touched.drivers && errors.drivers ? (
                        <FormFeedback style={{ display: "block" }}>
                          {errors.drivers}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="vehicle" className="passwordLabel">
                        Vehicle
                      </Label>
                      <Select
                        name="vehicle"
                        classNamePrefix="select"
                        options={vehicleOptions}
                        value={vehicleOptions.find(opt => String(opt.value) === String(values.vehicle)) || null}
                        onChange={(selectedOption) => {
                          setFieldValue("vehicle", selectedOption?.value || "");
                        }}
                        onBlur={() => handleBlur({ target: { name: "vehicle" } })}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#f4f4f4",
                            border: "none",
                            borderBottom: "1px solid #8d8d8d",
                            minHeight: "44px",
                            height: "43px",
                            boxShadow: "none",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "43px",
                            padding: "0 6px",
                            overflow: "auto",
                            backgroundColor: "transparent",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "43px",
                            backgroundColor: "transparent",
                          }),
                        }}
                      />
                      {touched.vehicle && errors.vehicle ? (
                        <FormFeedback style={{ display: "block" }}>{errors.vehicle}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>


                  <Col md={6}>
                    <FormGroup>
                      <Label for="start_location" className="passwordLabel">
                        Departure location
                      </Label>
                      <Input
                        type="text"
                        name="start_location"
                        id="start_location"
                        className="profileInput"
                        placeholder="Enter Departure Location"
                        value={values.start_location}
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("start_location", e.target.value)
                        }
                        invalid={
                          touched.start_location && errors.start_location
                            ? true
                            : false
                        }
                      />
                      {touched.start_location && errors.start_location ? (
                        <FormFeedback>{errors.start_location}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="start_date" className="passwordLabel">
                        Departure Date
                      </Label>
                      <Input
                        type="date"
                        name="start_date"
                        id="start_date"
                        className="profileInput"
                        value={values.start_date}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("start_date", e.target.value)}
                        invalid={touched.start_date && errors.start_date ? true : false}
                      />
                      {touched.start_date && errors.start_date ? (
                        <FormFeedback>{errors.start_date}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="start_time" className="passwordLabel">
                        Departure Time
                      </Label>
                      <Input
                        type="time"
                        name="start_time"
                        id="start_time"
                        className="profileInput"
                        value={values.start_time}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("start_time", e.target.value)}
                        invalid={touched.start_time && errors.start_time ? true : false}
                      />
                      {touched.start_time && errors.start_time ? (
                        <FormFeedback>{errors.start_time}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="end_location" className="passwordLabel">
                        Arrival location
                      </Label>
                      <Input
                        type="text"
                        name="end_location"
                        id="end_location"
                        className="profileInput"
                        placeholder="Enter Arrival Location"
                        value={values.end_location}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("end_location", e.target.value)}
                        invalid={touched.end_location && errors.end_location ? true : false}
                      />
                      {touched.end_location && errors.end_location ? (
                        <FormFeedback>{errors.end_location}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="end_date" className="passwordLabel">
                        Arrival Date
                      </Label>
                      <Input
                        type="date"
                        name="end_date"
                        id="end_date"
                        className="profileInput"
                        value={values.end_date}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("end_date", e.target.value)}
                        invalid={touched.end_date && errors.end_date ? true : false}
                      />
                      {touched.end_date && errors.end_date ? (
                        <FormFeedback>{errors.end_date}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="end_time" className="passwordLabel">
                        Arrival Time
                      </Label>
                      <Input
                        type="time"
                        name="end_time"
                        id="end_time"
                        className="profileInput"
                        value={values.end_time}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("end_time", e.target.value)}
                        invalid={touched.end_time && errors.end_time ? true : false}
                      />
                      {touched.end_time && errors.end_time ? (
                        <FormFeedback>{errors.end_time}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="half" className="passwordLabel">
                        Half
                      </Label>
                      <Input
                        type="text"
                        name="half"
                        id="half"
                        className="profileInput"
                        placeholder="Enter Half"
                        value={values.half}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("half", e.target.value)}
                        invalid={touched.half && errors.half ? true : false}
                      />
                      {touched.half && errors.half ? (
                        <FormFeedback>{errors.half}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="price_per_km" className="passwordLabel">
                        Price Per KM
                      </Label>
                      <Input
                        type="number"
                        name="price_per_km"
                        id="price_per_km"
                        className="profileInput"
                        placeholder="Enter Price Per KM"
                        value={values.price_per_km}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("price_per_km", e.target.value)}
                        invalid={touched.price_per_km && errors.price_per_km ? true : false}
                      />
                      {touched.price_per_km && errors.price_per_km ? (
                        <FormFeedback>{errors.price_per_km}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="state" className="passwordLabel">
                        State
                      </Label>
                      <Input
                        type="select"
                        name="state"
                        id="state"
                        className="profileInput"
                        value={values.state}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("state", e.target.value)}
                        invalid={touched.state && errors.state ? true : false}
                      >
                        <option value="">Select State</option>
                        {stateList.map(({ value, label }) => (
                          <option key={value} value={value}>
                            {label}
                          </option>
                        ))}
                      </Input>
                      {touched.state && errors.state ? (
                        <FormFeedback>{errors.state}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="invoice_reference" className="passwordLabel">
                        Invoice Reference
                      </Label>
                      <Input
                        type="text"
                        name="invoice_reference"
                        id="invoice_reference"
                        className="profileInput"
                        placeholder="Enter invoice reference"
                        value={values.invoice_reference}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("invoice_reference", e.target.value)}
                        invalid={touched.invoice_reference && errors.invoice_reference ? true : false}
                      />
                      {touched.invoice_reference && errors.invoice_reference ? (
                        <FormFeedback>{errors.state}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="invoice" className="passwordLabel">
                        Invoice
                      </Label>
                      <Input
                        type="text"
                        name="invoice"
                        id="invoice"
                        className="profileInput"
                        placeholder="Enter invoice"
                        value={values.invoice}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("invoice", e.target.value)}
                        invalid={touched.invoice && errors.invoice ? true : false}
                      />
                      {touched.invoice && errors.invoice ? (
                        <FormFeedback>{errors.state}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="notes" className="passwordLabel">
                        Notes
                      </Label>
                      <Input
                        type="text"
                        name="notes"
                        id="notes"
                        className="profileInput"
                        placeholder="Enter notes"
                        value={values.notes}
                        onBlur={handleBlur}
                        onChange={(e) => setFieldValue("notes", e.target.value)}
                        invalid={touched.notes && errors.notes ? true : false}
                      />
                      {touched.notes && errors.notes ? (
                        <FormFeedback>{errors.state}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
    </TripModal>
  );
};
